<h1 mat-dialog-title class="cardTitle">
    Welcome to Our Checkout!
    <button mat-mini-fab class="cardClose" (click)="close()">
        <i class="material-icons" data-icon="close"></i>
    </button>
</h1>

<mat-dialog-content class="CardContent">
    <p>
        To continue with your purchase, please login or register for an account.
        Don't worry, it only takes a minute, and you'll be brought right back
        afterward.
    </p>
</mat-dialog-content>
<mat-dialog-actions align="end" class="cardFooter">
    <ng-container *ngIf="featureTags && featureTags['ftags_membership']">
        <button mat-button (click)="redirectTo(data['membershipPoduct'])">Proceed</button>
    </ng-container>
    <ng-container *ngIf="featureTags && !featureTags['ftags_membership']">
        <button mat-button (click)="redirectTo()">Proceed</button>
    </ng-container>
</mat-dialog-actions>
